
import { RouteConfig } from './types';
import EmailApp from '../pages/email/EmailApp';
import EmailDetailView from '../pages/email/EmailDetailView';
import EmailTemplatesPage from '../pages/email/EmailTemplatesPage';
import Chat from '../pages/Chat';
import Dialer from '../pages/Dialer';

export const communicationRoutes: RouteConfig[] = [
  // Main email app route - handles all email sub-routes through EmailLayout
  { path: "/app/email/*", element: EmailApp, requiresLayout: true, requiredPermissions: ['email.read'] },
  { path: "/app/email-templates", element: EmailTemplatesPage, requiresLayout: true, requiredPermissions: ['email_template.read'] },
  { path: "/app/chat", element: Chat, requiresLayout: true, requiredPermissions: ['chat.read'] },
  { path: "/app/dialer", element: Dialer, requiresLayout: true, requiredPermissions: ['dialer.read'] },
  // Alias for older links/bookmarks
  { path: "/app/phone", element: Dialer, requiresLayout: true, requiredPermissions: ['dialer.read'] }
];
